<template>
  <v-col cols="12" v-if="filterTypeId > -1">
    <div>
      <div v-if="isLoaderActive" class="loaderWrapper">
        <div class="progressWrapper">
          <v-progress-circular :size="70" :width="7" color="red" indeterminate class="spinner" />
        </div>
      </div>
      <div v-if="!isLoaderActive" class="filtersViewerWrapper">

        <div v-if="filterTypeId == 1" class="filterType1 filtersViewerInnerWrapper">
          <v-autocomplete clearable v-model="fields.apptDaysFrom" :items="FilterFields.alldays"
            label="Appointment:DaysFrom" item-text="label" item-value="value" required
            :error="!(fields.apptDaysFrom && fields.apptDaysFrom.length) && isFormDirty" />

          <v-autocomplete clearable v-model="fields.apptStatus" :items="optionsMeta ? optionsMeta.allStatus : []"
            label="Appointment:Status" item-text="status" item-value="status" required multiple chips
            :error="!(fields.apptStatus && fields.apptStatus.length) && isFormDirty" />

          <v-autocomplete clearable v-model="fields.apptFacility" :items="optionsMeta && optionsMeta.allFacilities || []"
            label="Appointment:Facility" item-text="name" item-value="id" required multiple chips
            :error="!(fields.apptFacility && fields.apptFacility.length) && isFormDirty" />

          <v-autocomplete clearable v-model="fields.apptProvider" :items="optionsMeta && optionsMeta.allProviders || []"
            label="Appointment:Provider" item-text="label" item-value="id" required multiple chips
            :error="!(fields.apptProvider && fields.apptProvider.length) && isFormDirty" />

          <v-autocomplete clearable v-model="fields.apptType" :items="optionsMeta && optionsMeta.allApptTypes || []" label="Appointment:Type"
            item-text="type" item-value="type" required multiple chips
            :error="!(fields.apptType && fields.apptType.length) && isFormDirty" />

        </div>

        <div v-if="filterTypeId == 2" class="filterType2 filtersViewerInnerWrapper">

          <v-autocomplete clearable v-model="fields.apptFacility" :items="optionsMeta && optionsMeta.allFacilities || []"
            label="Appointment:Facility" item-text="name" item-value="id" required multiple chips
            :error="!(fields.apptFacility && fields.apptFacility.length) && isFormDirty" />

          <v-autocomplete clearable v-model="fields.dueRangeStart" :items="FilterFields.dueRange" label="PastDueRange:Start *"
            item-text="label" item-value="value" required
            :error="!(fields.dueRangeStart && fields.dueRangeStart.length) && isFormDirty" />

          <v-autocomplete clearable v-model="fields.dueRangeEnd" :items="FilterFields.dueRange" label="PastDueRange:End *"
            item-text="label" item-value="value" required
            :error="!(fields.dueRangeEnd && fields.dueRangeEnd.length) && isFormDirty" />

          <v-text-field v-model="fields.pastDueMin" item-text="label" item-value="value" label="PastDue:Min" />
          <v-text-field v-model="fields.pastDueMax" item-text="label" item-value="value" label="PastDue:Max" />

        </div>

        <div v-if="filterTypeId == 3" class="filterType3 filtersViewerInnerWrapper">

          <v-autocomplete clearable v-model="fields.ageStart" :items="FilterFields.ageRange" label="Age:Start"
            item-text="label" item-value="value" required
            :error="!(fields.ageStart && fields.ageStart.length) && isFormDirty" />

          <v-autocomplete clearable v-model="fields.ageEnd" :items="FilterFields.ageRange" label="Age:End"
            item-text="label" item-value="value" required
            :error="!(fields.ageEnd && fields.ageEnd.length) && isFormDirty" />
        </div>

      </div>
    </div>
  </v-col>
</template>
<script>
  /* eslint-disable */
import FilterFields from "./filter-fields";
import FilterEditorHelperMethods from "./filter-editor-helper-methods";

export default {
  name: "DynamicGroupFiltersEditor",
  props: {
    filterTypeId: {
      type: Number,
      default: -1
    },
    filterFields: {
      type: Array,
      default: null
    },
    allFilterOptions: {
      type: Array,
      default: null
    },
    isFormDirty: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isLoaderActive: false,
    shouldShowFilters: false,
    FilterFields: FilterFields,
    FilterEditorHelperMethods: FilterEditorHelperMethods,
    fields: {
      apptDaysFrom: '',
      apptStatus: '',
      apptFacility: '',
      apptProvider: '',
      apptType: '',
      dueRangeStart: '',
      dueRangeEnd: '',
      pastDueMin: '',
      pastDueMax: '',
      ageStart: '',
      ageEnd: '',
    },
    optionsMeta: {
      allStatus: [],
      allFacilities: [],
      allProviders: [],
      allApptTypes: [],
    },
    filterTypeMappedIds: {}
  }),
  watch: {
    filterTypeId(val) {
      if (val > 0) {
        this._resetFields();
        this._loadFilters(val);
        this._setStateValues();
      }
    },
    allFilterOptions(val) {
      console.log('allFilterOptions 122221', val)
      // this._updateParent();
    },
    group(val) {
      // console.log('group 122221', val)
      // this._updateParent();
    }
  },
  created() {
    this._initiateLoad();
  },
  methods: {
    _initiateLoad() {
      console.log('Editor initiated');
      if (this.$store.state.posActivePractice) {
        this._loadMetaData();
        this._loadFilters(this.filterTypeId);
        this._setStateValues();
      }
    },
    async _loadMetaData() {
      // this.isLoaderActive = true;
      this.optionsMeta = await FilterEditorHelperMethods.fetchAndFormatOptions(this.$store.state.posActivePractice.value);
      console.log('this.optionsMeta 122221', this.optionsMeta)
      this.isLoaderActive = false;
    },
    _resetFields() {
      console.log('reseting');
      this.fields = {
        apptDaysFrom: '',
        apptStatus: '',
        apptFacility: '',
        apptProvider: '',
        apptType: '',
        dueRangeStart: '',
        dueRangeEnd: '',
        pastDueMin: '',
        pastDueMax: '',
        ageStart: '',
        ageEnd: '',
      }
    },
    async _loadFilters(filterId) {
      // console.log('filterId :>> ', filterId);
      // console.log('this.filterTypeId', this.filterTypeId);
      // console.log('group 122221', this.group)
      console.log('allFilterOptions 122221', this.allFilterOptions)
      this.isLoaderActive = true;
      this.filterTypeMappedIds = await FilterEditorHelperMethods.fetchAndFormatFilterDataTypes(filterId);
      this.filterTypeId = filterId;
      console.log('this.filterTypeMappedIds 122221:>> ', this.filterTypeMappedIds);
      this.isLoaderActive = false;
      console.log('this.isLoaderActive 122221:>> ', this.isLoaderActive);
    },
    _onFilterValueUpdate() {
      const updatedFilters = FilterEditorHelperMethods.prepareStateToPropsFields(this.fields);
      console.log('updatedFilters :>> ', updatedFilters);
      this.$emit("update-filters", updatedFilters);
    },
    _setStateValues() {
      console.log('this.filterFields 5554', this.filterFields)
      this.fields = FilterEditorHelperMethods.preparePropsToStateFields(this.filterFields);
    }
  },
};
</script>
<style lang="scss" scoped>
.progressWrapper {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  .spinner {
    margin-left: 0rem !important;
  }

  flex-direction: column;

  img {
    margin-bottom: 25px;
  }
}
</style>
